/**
 * @type {{ NONE: "0", MONTH: "1", CUSTOM: "2" }}
 */
export const RepeatType = Object.freeze({
    NONE: "0",
    MONTH: "1",
    CUSTOM: "2"
});